module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Dados Pessoais\n                "), (_vm.recadastramentos.length > 1) ? _c('span', [_vm._v("- " + _vm._s(_vm._f("formataRegistro")(_vm.cadastro.registro)))]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row row-input"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(this.recadastramentos.length > 1) ? _c('div', {
    staticClass: "col-md-3 col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastro),
      expression: "cadastro"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cadastro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.trocaRegistro(_vm.cadastro.id)
      }]
    }
  }, _vm._l((_vm.recadastramentos), function(recadastramento) {
    return _c('option', {
      key: recadastramento.id,
      domProps: {
        "value": recadastramento
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("formataRegistro")(('Registro ' + recadastramento.registro))) + "\n                        ")])
  }), 0)])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "margin-bottom": "2rem"
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.nome),
      expression: "cadastrado.pessoa.nome"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "id": "nome",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO',
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa, "nome", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
  }, [_c('label', {
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("cpfMask")(_vm.cadastrado.cpf)))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
  }, [_c('field-validation', {
    attrs: {
      "status": _vm.errors,
      "label": "Orientação Sexual",
      "custom-errors": _vm.apiErrors,
      "show-icon": false,
      "field": "orientacaoSexual"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.orientacaoSexual),
      expression: "cadastrado.pessoa.orientacaoSexual"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "orientacaoSexual",
      "data-vv-as": "Orientação Sexual",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa, "orientacaoSexual", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.orientacoesSexuais), function(orientacaoSexual) {
    return _c('option', {
      key: orientacaoSexual.name,
      domProps: {
        "value": orientacaoSexual.name
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("tudoMaiusculo")(orientacaoSexual.displayName)) + "\n                      ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-3 col-sm-6 paragrafosPertoDeInput"
  }, [_c('field-validation', {
    attrs: {
      "status": _vm.errors,
      "label": "Identidade de Gênero",
      "custom-errors": _vm.apiErrors,
      "show-icon": false,
      "field": "genero"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.genero),
      expression: "cadastrado.pessoa.genero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "genero",
      "data-vv-as": "Identidade de Gênero",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa, "genero", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.generos), function(genero) {
    return _c('option', {
      key: genero.name,
      domProps: {
        "value": genero.name
      }
    }, [_vm._v("\n                            " + _vm._s(_vm._f("tudoMaiusculo")(genero.displayName)) + "\n                          ")])
  })], 2)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-3"
  }, [(!_vm.cadastrado.lancamentoPermitido) ? _c('div', [_c('campo-calendario', {
    attrs: {
      "disabled": _vm.situacaoRecad === 'CONFIRMADO',
      "rotulo": "Data de Nascimento",
      "nome": "dataNascimento",
      "data-maxima": _vm.dezoitoAnosAtras,
      "validacao": {
        required: true
      }
    },
    model: {
      value: (_vm.cadastrado.pessoa.dataNascimento),
      callback: function($$v) {
        _vm.$set(_vm.cadastrado.pessoa, "dataNascimento", $$v)
      },
      expression: "cadastrado.pessoa.dataNascimento"
    }
  })], 1) : _c('div', [_c('label', {
    attrs: {
      "for": "dataEmissao"
    }
  }, [_vm._v("Data da Emissão")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput form-control",
    staticStyle: {
      "background-color": "#eeee",
      "opacity": "1"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.formatarData(_vm.cadastrado.pessoa.dataNascimento)) + "\n                        ")])])]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-3 col-sm-3",
      "label": "Raça/Cor",
      "field": "cor",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.racaCor),
      expression: "cadastrado.pessoa.racaCor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cor",
      "data-vv-as": "Raça/Cor",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa, "racaCor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.cores), function(cor) {
    return _c('option', {
      key: cor.name,
      domProps: {
        "value": cor.name
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("tudoMaiusculo")(cor.displayName)) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-3 col-sm-3",
      "label": "Estado Civil",
      "field": "estadoCivil",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.estadoCivil),
      expression: "cadastrado.pessoa.estadoCivil"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estadoCivil",
      "data-vv-as": "Estado Civil",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa, "estadoCivil", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.estadosCivis), function(estadoCivil) {
    return _c('option', {
      key: estadoCivil.name,
      domProps: {
        "value": estadoCivil.name
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("tudoMaiusculo")(estadoCivil.displayName)) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-3"
  }, [_c('label', {
    attrs: {
      "for": "grauInstrucao"
    }
  }, [_vm._v("Grau de Escolaridade")]), _vm._v(" "), _c('p', {
    staticClass: "textoAlinhadoAoInput"
  }, [_vm._v("\n                        " + _vm._s(_vm.grauInstrucaoDisplay) + "\n                      ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    directives: [{
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }],
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Município de Nascimento",
      "field": "municipioNaturalidade",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.naturalidade.cidade),
      expression: "cadastrado.pessoa.naturalidade.cidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:40'),
      expression: "'required|max:40'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "municipioNaturalidade",
      "id": "municipioNaturalidade",
      "data-vv-as": "Município",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    domProps: {
      "value": (_vm.cadastrado.pessoa.naturalidade.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cadastrado.pessoa.naturalidade, "cidade", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Estado de Nascimento",
      "field": "ufNaturalidade",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.naturalidade.uf),
      expression: "cadastrado.pessoa.naturalidade.uf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.ehBrasil
      }),
      expression: "{ required: ehBrasil }"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ufNaturalidade",
      "data-vv-as": "Estado",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa.naturalidade, "uf", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.ufs), function(uf) {
    return _c('option', {
      key: uf.id,
      domProps: {
        "value": uf.sigla
      }
    }, [_vm._v("\n                          " + _vm._s(_vm._f("tudoMaiusculo")(uf.nome)) + "\n                        ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Nacionalidade",
      "field": "nacionalidade",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cadastrado.pessoa.naturalidade.pais),
      expression: "cadastrado.pessoa.naturalidade.pais"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nacionalidade",
      "data-vv-as": "Nacionalidade",
      "disabled": _vm.cadastrado.lancamentoPermitido || _vm.situacaoRecad === 'CONFIRMADO'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cadastrado.pessoa.naturalidade, "pais", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.paises), function(pais) {
    return _c('option', {
      key: pais,
      domProps: {
        "value": pais
      }
    }, [_vm._v("\n                          " + _vm._s(pais) + "\n                        ")])
  })], 2)])], 1)])], 1)])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "controller"
    }
  }, [_c('div', {
    staticClass: "container footer-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('botao', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Desfaz alterações de todas as etapas'),
      expression: "'Desfaz alterações de todas as etapas'",
      modifiers: {
        "right": true
      }
    }],
    attrs: {
      "estilo": "cheio-cinza-esq",
      "rotulo": "Desfazer",
      "icone": "fa-undo"
    },
    on: {
      "clicado": function($event) {
        return _vm.recarregaDados()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Avançar",
      "icone": "avancar",
      "icone-direita": true
    },
    on: {
      "clicado": function($event) {
        return _vm.avanca(_vm.recadastramentos, _vm.ufs, _vm.cadastrado, 'Endereco')
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "margin-bottom": "15px",
      "text-align": "justify"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle fa-lg"
  }), _vm._v("  "), _c('strong', [_vm._v("Atenção:")]), _vm._v(" Para alterações de nome deve ser anexado o CPF atualizado da Receita Federal. Baixar no link: https://servicos.receita.fazenda.gov.br/servicos/cpf/consultasituacao/consultapublica.asp\n              ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b12d1e0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/recadastramento/dados-pessoais/index.vue
// module id = 60R7
// module chunks = 5